// Action types for fetching orders
export const FETCH_DOWNLOAD_BULK_STATUS_REQUEST = 'FETCH_DOWNLOAD_BULK_STATUS_REQUEST';
export const FETCH_DOWNLOAD_BULK_STATUS_SUCCESS = 'FETCH_DOWNLOAD_BULK_STATUS_SUCCESS';
export const FETCH_DOWNLOAD_BULK_STATUS_FAILURE = 'FETCH_DOWNLOAD_BULK_STATUS_FAILURE';
export const FETCH_DOWNLOAD_BULK_STATUS_RESET = 'FETCH_DOWNLOAD_BULK_STATUS_RESET';
// Fetch data actions
export const fetchDownloadBulkStatusRequest = (payload) => ({
    type: FETCH_DOWNLOAD_BULK_STATUS_REQUEST,
    payload,
});
export const fetchDownloadBulkStatusSuccess = (payload) => ({
    type: FETCH_DOWNLOAD_BULK_STATUS_SUCCESS,
    payload,
});
export const fetchDownloadBulkStatusFailure = (error) => ({
    type: FETCH_DOWNLOAD_BULK_STATUS_FAILURE,
    payload: error,
});
export const fetchDownloadBulkStatusReset = () => ({
    type: FETCH_DOWNLOAD_BULK_STATUS_RESET,
});
